/**
 * Provider vocabulary definitions
 */
export const providerVocabularies = {
    gitlab: {
        name: 'GitLab',
        pullRequest: 'merge request',
        pullRequests: 'merge requests',
        pullRequestsShort: 'MRs',
    },
    gitea: {
        name: 'Gitea',
        pullRequest: 'pull request',
        pullRequests: 'pull requests',
        pullRequestsShort: 'PRs',
    },
};
const defaultVocabulary = {
    name: 'Git',
    pullRequest: 'pull request',
    pullRequests: 'pull requests',
    pullRequestsShort: 'PRs',
};
/**
 * Get the vocabulary for a provider.
 * @param provider The provider name (e.g., 'gitlab', 'gitea')
 * @returns The vocabulary for the provider, or a default if not found
 */
export function getProviderVocabulary(provider) {
    return providerVocabularies[provider] ?? defaultVocabulary;
}
/**
 * Map kiln BuildStatus to CommitStatusState
 */
export function buildStatusToCommitState(status) {
    switch (status) {
        case 'pending':
            return 'pending';
        case 'running':
            return 'running';
        case 'success':
            return 'success';
        case 'failed':
            return 'failed';
        case 'cancelling':
        case 'cancelled':
            return 'cancelled';
        default:
            return 'failed';
    }
}
// Note: GitIntegrationConfigSchema is defined in types/index.ts
//# sourceMappingURL=types.js.map